import React from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import './ConsumerList.css';
import { v4 as uuidv4 } from 'uuid';
import swal from 'sweetalert';
import tokenErrorHandler from "../tokenErrorHandler";
import history from "../../auth/history";
const httpClient = axios.create();
class ConsumerList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			errorMsg: '',
			resetLoading: false,
			deleteLoading: false
		}
	}

	componentDidMount() { }
	componentWillUnmount() {
	}

	resetConsumer = (e, consumer) => {
		e.preventDefault();
		var requesterId = this.props.clientRequesterId;

		this.setState({
			resetLoading: true
		})

		const header = {
			msgType: "STATUS_UPDATE",
			service: "billpay-corporate-dashboard",
			src: "consumer-list",
			dst: "consumer-list",
			channel: "WEB",
			requesterId: requesterId,
			requestId: uuidv4(),
			traceId: uuidv4(),
		}

		var request = {
			header: header,
			consumerId: consumer.id,
			agentId: this.props.agentInfo
		}


		const url = "/api/v1/billpay/corp/consumer/reset";

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}
		// alert(JSON.stringify(request))

		httpClient.post(url, request,
			{ headers }
		).then((response) => {


			this.setState({
				resetLoading: false
			})
			if (response.data.response.success == true) {
				//store.dispatch(setConsumerAddresp(response.data.addedConsumer));

				setTimeout(() => {
					swal({
						title: "Consumer Reset Done.",
						text: '',
						icon: "",
						button: true,
						dangerMode: false,
					}).then(() => {
						history.push('/all-consumer');
						history.go();
					});
				}, 400);


			} else {
				swal({
					title: "Error!",
					text: 'Consumer reset failed',
					icon: "error",
					button: true,
					dangerMode: true,
				}).then(() => {

				});
				this.setState({
					errorMsg: response.data.response.displayMsg
				})
			}

		}).catch(error => {
			this.setState({
				resetLoading: false
			})

			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			} else {
				swal({
					title: "Error!",
					text: 'Consumer reset failed',
					icon: "error",
					button: true,
					dangerMode: true,
				}).then(() => {

				});
			}

		});
	}

	deleteConsumer = (e, consumer) => {
		e.preventDefault();
		var requesterId = this.props.clientRequesterId;

		this.setState({
			deleteLoading: true
		})
		const header = {
			msgType: "STATUS_UPDATE",
			service: "billpay-corporate-dashboard",
			src: "consumer-list",
			dst: "consumer-list",
			channel: "WEB",
			requesterId: requesterId,
			requestId: uuidv4(),
			traceId: uuidv4(),
		}

		var request = {
			header: header,
			consumerId: consumer.id,
			agentId: this.props.agentInfo
		}


		const url = "/api/v1/billpay/corp/consumer/delete";

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}


		httpClient.post(url, request,
			{ headers }
		).then((response) => {
			this.setState({
				deleteLoading: false
			})
			if (response.data.response.success == true) {
				//store.dispatch(setConsumerAddresp(response.data.addedConsumer));
				setTimeout(() => {
					swal({
						title: "Consumer deleted.",
						text: '',
						icon: "",
						button: true,
						dangerMode: false,
					}).then(() => {
						history.push('/all-consumer');
						history.go();

					});
				}, 400);


			} else {
				swal({
					title: "Error!",
					text: 'Consumer delete failed',
					icon: "error",
					button: true,
					dangerMode: true,
				}).then(() => {

				});
				this.setState({
					errorMsg: response.data.response.displayMsg
				})

			}

		}).catch(error => {
			this.setState({
				deleteLoading: false
			})

			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			} else {
				swal({
					title: "Error!",
					text: 'Consumer delete failed',
					icon: "error",
					button: true,
					dangerMode: true,
				}).then(() => {

				});
			}

		});
	}


	render() {

		return (
			<div class="cnsmr-count">
				<div class="txn-head" id={"csmrhead" + this.props.consumerVal.id}>
					<div class="collapsed" data-bs-toggle="collapse" data-bs-target={"#cnsmr" + this.props.consumerVal.id} aria-expanded="false" aria-controls={"cnsmr" + this.props.consumerVal.id}>
						<div class="consumrlist nodue">
							<div class="row">
								<div class="col-12 col-sm-6 col-lg-3">
									<div class="consumr">
										{this.props.consumerVal.active == true &&
											<h4 class="active">{this.props.consumerVal.consumerName}</h4>
										}
										{this.props.consumerVal.active != true &&
											<h4>{this.props.consumerVal.consumerName}</h4>
										}
										<p>+91-{this.props.consumerVal.mobileNo}</p>
										<p class="date">{moment(this.props.consumerVal.createdOn).format('DD-MM-YYYY HH:mm:ss')}</p>
									</div>
								</div>

								<div class="col-12 col-sm-6 col-lg-4">
									<div class="consumr">
										<h5>{this.props.consumerVal.billerName}</h5>
										{/* <h5>{Object.entries(this.props.consumerVal.optional).map(([key, value]) => `${value}`).join('').replace("{", '').
											replace("}", "")}</h5> */}
										{this.props.consumerOptionalKeys.length > 0 &&

											this.props.consumerOptionalKeys.map(key => (
												(
													key.id == this.props.consumerVal.id &&
													<p>{key.key.split("_").join(" ")} : {key.value}</p>
												)
											))

										}
										{this.props.consumerVal.lastActivityMsg != undefined &&
											this.props.consumerVal.lastActivityMsg != null &&
											<h7>Message: {this.props.consumerVal.lastActivityMsg.split('_').join(' ')}</h7>
										}

									</div>
								</div>

								<div class="col-6 col-sm-3 col-lg">
									<div class="consumr">
										<p>Bill Amount</p>
										<h5>₹ {(this.props.consumerVal.currentBillPayAmount != undefined &&
											this.props.consumerVal.currentBillPayAmount != null &&
											this.props.consumerVal.currentBillPayAmount != "") ?
											this.props.consumerVal.currentBillPayAmount :
											(this.props.consumerVal.lastPaidBill != undefined &&
												this.props.consumerVal.lastPaidBill != null &&
												this.props.consumerVal.lastPaidBill != "" &&
												this.props.consumerVal.lastPaidBill.lastPaidBillAmount != undefined &&
												this.props.consumerVal.lastPaidBill.lastPaidBillAmount != null &&
												this.props.consumerVal.lastPaidBill.lastPaidBillAmount) != "" ?
												this.props.consumerVal.lastPaidBill.lastPaidBillAmount :

												"NA"
										}</h5>
									</div>
								</div>

								<div class="col-6 col-sm-3 col-lg">
									<div class="consumr text-end text-sm-start">
										<p>Bill Date</p>
										<h5>{(this.props.consumerVal.lastBillFetch != null &&
											this.props.consumerVal.lastBillFetch.billDate != undefined &&
											this.props.consumerVal.lastBillFetch.billDate != "" &&
											this.props.consumerVal.lastBillFetch.billDate != null) ?
											this.props.consumerVal.lastBillFetch.billDate :
											"NA"
										}</h5>
									</div>
								</div>

								<div class="col-6 col-sm-3 col-lg">
									<div class="consumr">
										<p>Bill Due Date</p>
										<h5>{(this.props.consumerVal.lastBillFetch != null &&
											this.props.consumerVal.lastBillFetch.dueDate != undefined &&
											this.props.consumerVal.lastBillFetch.dueDate != "" &&
											this.props.consumerVal.lastBillFetch.dueDate != null) ?
											this.props.consumerVal.lastBillFetch.dueDate :
											"NA"
										}</h5>
									</div>
								</div>

								<div class="col-6 col-sm-3 col-lg col-xl-1">
									<div class="consumr text-end">
										<p>Last Status:</p>
										
										<h5 class="nodues">{this.props.consumerVal.lastKnownStatus.split("_").join(" ")}
										{this.props.consumerVal.billFetchFailedBeforeBillPay!=undefined &&
										this.props.consumerVal.billFetchFailedBeforeBillPay!=null &&
										this.props.consumerVal.billFetchFailedBeforeBillPay==true &&('(Manual-Billpay)')}</h5>

									</div>

								</div>
								<div class="col-6 col-sm-3 col-lg col-xl-1">
									<div class="consumr text-end">
										{this.state.resetLoading == false &&
											<button type="button" class="lbbtn" onClick={e => this.resetConsumer(e, this.props.consumerVal)} >Reset </button>
										}
										{this.state.deleteLoading == false &&
											<button type="button" class="lbbtn" onClick={e => this.deleteConsumer(e, this.props.consumerVal)}>Delete </button>
										}
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

				<div id={"cnsmr" + this.props.consumerVal.id} class="accordion-collapse collapse" aria-labelledby={"csmrhead" + this.props.consumerVal.id} data-bs-parent={"#cnsmrlist"}>
					<div class="cnsmrsubtxt">

						<div class="csmrdtl">
							<div class="row">
								<div class="col-6 col-md col-lg-3">
									<div class="cnsmrsubdtl">
										<p>Last Bill Paid Amount:</p>
										<h5>₹ {(this.props.consumerVal.lastPaidBill != null &&
											this.props.consumerVal.lastPaidBill != undefined &&
											this.props.consumerVal.lastPaidBill != "" &&
											this.props.consumerVal.lastPaidBill.lastPaidBillAmount != null &&
											this.props.consumerVal.lastPaidBill.lastPaidBillAmount != "" &&
											this.props.consumerVal.lastPaidBill.lastPaidBillAmount != undefined
										) ?
											this.props.consumerVal.lastPaidBill.lastPaidBillAmount :
											"NA"
										}</h5>
									</div>
								</div>

								<div class="col-6 col-md col-lg-4">
									<div class="cnsmrsubdtl text-end text-md-start">
										<p>Last Bill Paid Date:</p>
										<h5>{(this.props.consumerVal.lastPaidBill != null &&
											this.props.consumerVal.lastPaidBill != undefined &&
											this.props.consumerVal.lastPaidBill != "" &&
											this.props.consumerVal.lastPaidBill.lastPaidBillDate != null &&
											this.props.consumerVal.lastPaidBill.lastPaidBillDate != "" &&
											this.props.consumerVal.lastPaidBill.lastPaidBillDate != undefined) ?
											moment(this.props.consumerVal.lastPaidBill.lastPaidBillDate).format('DD-MM-YYYY HH:mm:ss') :
											"NA"}</h5>
									</div>
								</div>

								<div class="col-6 col-md">
									<div class="cnsmrsubdtl">
										<p>Early Pay Amount:</p>
										<h5>₹ 0.00</h5>
									</div>
								</div>

								<div class="col-6 col-md">
									<div class="cnsmrsubdtl text-end">
										<p>Early Pay Date:</p>
										<h5>00-00-0000</h5>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, },
		miscReduce: { phone, token, agentInfo, clientRole,clientRequesterId } }
) => ({
	errorMessage, phone, token, agentInfo, clientRole,clientRequesterId
});

export default connect(mapStateToProps, null)(ConsumerList);
